import { Tooltip } from "antd";
import { memo } from "react";
import { UtilService } from "src/util/util.service";

export interface CustomTextTooltipProps {
  value?: string;
  textLength?: number;
}

function CustomTextTooltip({ value = "", textLength = 15 }: CustomTextTooltipProps) {
  return (
    <Tooltip title={value.length > textLength ? value : ""} placement="top">
      <div>{UtilService.textLimit(value, textLength)}</div>
    </Tooltip>
  );
}

export default memo(CustomTextTooltip);
